import reduxStore from "../configureEnvStore";
import { setWaitingBarWidth } from "../reducers/common-reducer";

class WaitingScreenService {
    waitingbar = null;

    showProgressBar(displayProgress) {
        if (displayProgress) {
            this.waitingbar = setInterval(() => {
                let width = reduxStore.getState().commonReducer.waitingBarWidth;
                if (width >= 100) {
                    clearInterval(this.waitingbar);
                    this.waitingbar = null;
                } else {
                    reduxStore.dispatch(setWaitingBarWidth(width + 1));
                }
            }, 1720);
        } else {
            if (this.waitingbar) {
                clearInterval(this.waitingbar);
                reduxStore.dispatch(setWaitingBarWidth(0));
                this.waitingbar = null;
            } else {
                console.log("waitingbar =>", this.waitingbar);
            }
        }
    }
}
export default new WaitingScreenService();
